import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  created() {
    console.log(
      "%c Modern English 📷",
      "color: white; background: black; padding: 4px 4px;"
    );
  },
}).$mount("#app");
